import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAg9ipJEG7yUbOBEVts9XCO0KBwGRWZFrg",
  authDomain: "eyerx-app.firebaseapp.com",
  projectId: "eyerx-app",
  storageBucket: "eyerx-app.firebasestorage.app",
  messagingSenderId: "1048832236394",
  appId: "1:1048832236394:web:33ef9a8b56c3047e3ba313",
};

const app = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// FCM messaging — only available in browsers that support it
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  // Safari / non-supporting environments
}
export { messaging };

const VAPID_KEY = "BAIAtlPBV1EfeMZ2qThDAjtt-vflry2KWNv9Kh9q6WiJ53PMVocb-6D-uOc9MbbjniTMdMG-wtT9Wr9thtPiin0";

export async function requestNotificationPermission() {
  if (!messaging) return "unsupported";
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return "denied";
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    return token ? "granted" : "denied";
  } catch (err) {
    console.error("Notification permission error:", err);
    return "error";
  }
}

export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
}
